/* eslint-disable */

import type { Address } from "viem"
import type { Config } from "wagmi"

import type { EmitEvent, Nft } from "@/domains/core"
import { EventEmitter } from "@/domains/library"
import { claimAllNftBribes } from "@/domains/on-chain"

export type ClaimAllNftBribesInteractionParams = {
  account: Address
  chainId: number
  config: Config
  voterAddress: Address
  nft: { id: number }
  bribes: Array<Address>
  bribeTokens: Array<Array<Address>>
  emitter: EventEmitter<EmitEvent>
  onClaimSuccess?: () => void
}

export const claimAllNftBribesInteraction = async ({
  account,
  chainId,
  config,
  voterAddress,
  nft,
  // rewardsForNft,
  bribes,
  bribeTokens,
  emitter,
  onClaimSuccess,
}: ClaimAllNftBribesInteractionParams) => {
  if (bribes.length === 0 || bribeTokens.every((v) => v.length === 0)) {
    emitter.emit("info", {
      title: "No bribes to claim",
      variant: "info",
    })
    return false
  }

  emitter.emit("claiming-all-nft-bribes", {
    title: "Claiming all NFT bribes",
    description: `Claiming bribes for #${nft.id}`,
    variant: "info",
  })

  const result = await claimAllNftBribes({
    account,
    chainId,
    config,
    voterAddress,
    // gauges: _gauges, // do we even use this? it could be an empty array here
    // gtokens: _gtokens, // do we even use this? it could be an empty array here
    bribes: bribes,
    btokens: bribeTokens,
    tokenId: nft.id,
  })

  // console.log("_gauges, _gtokens, _bribes, _btokens", _gauges, _gtokens, _bribes, _btokens)

  if (result && result.success === true) {
    onClaimSuccess?.()
    emitter.emit("claimed-all-nft-bribes", {
      title: "Claim All NFT bribes",
      description: `Claimed all bribes for NFT #${nft.id}`,
      variant: "success",
    })
    return result
  }
  if (result && result.success === false) {
    emitter.emit("error-claiming-all-nft-bribes", {
      title: `Claim All bribes for NFT #${nft.id}`,
      description: result.error,
      variant: "error",
    })
    return false
  }
  return false
}
